import { Inject, Injectable } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
 
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { AuthenticationResult, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';

 
@Injectable({
  providedIn: 'root'
})
export class MsalAuthService {
 
  private token: string | null = null;
  private tokenExpiryTime: any = 0;
 
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private http: HttpClient
    ) { }
 
  public getTokenSilent(): Observable<AuthenticationResult> {
    return this.authService.acquireTokenSilent(
      { scopes: ['user.read'], account: this.authService.instance.getAllAccounts()[0] })
      .pipe(map((x) => {
        let dateNow = new Date();
        dateNow.setHours(dateNow.getHours() + 4);        
          var claims:any=this.authService.instance.getActiveAccount()?.idTokenClaims;
          let strUsername = claims['preferred_username'].split("@");
           //let strRealUsername= strUsername[0]+"@tst."+strUsername[1];          
        return x;
      }), catchError((err: any) => {
        console.log(err, 'login error occured');
        //if (err.error === 'invalid_grant') {        
        
        this.login();
        //}
 
        throw err;
      })
    );
  }
 
  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {            
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {            
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }
 
  async saveAndGetTokenInSession(): Promise<any> {
     return await firstValueFrom(this.authService.acquireTokenSilent({ scopes: ['user.read'],forceRefresh:true, account: this.authService.instance.getAllAccounts()[0]}));
  }
 
  public setToken(tokenRes: any): void {
 
    window.sessionStorage.setItem('Token', JSON.stringify(tokenRes.idToken).replaceAll('"', ''));
    window.sessionStorage.setItem('userDetails', JSON.stringify(tokenRes));
    window.sessionStorage.setItem('idTokenExp', JSON.stringify(tokenRes.idTokenClaims.exp));
 
    this.token = JSON.stringify(tokenRes.idToken);
    this.tokenExpiryTime = tokenRes.idTokenClaims.exp;
  }
 
  public getToken(): string | null {
    this.token = window.sessionStorage.getItem('Token');
    return this.token;
  }
 
  isTokenExpired(): boolean {
    var idTokenExp = window.sessionStorage.getItem('idTokenExp');
    this.tokenExpiryTime = idTokenExp!=null?parseInt(idTokenExp):0;
    var currentTimeStamp = parseInt((Date.now()/1000).toString());
 
    return this.tokenExpiryTime < currentTimeStamp;
  }
 
  public logout() {    
    this.authService.logout();
  }  
 
}